import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/**
 * Checkout de ImpulTienda.
 * PENDIENTE: la tienda del DPS65 todavía no existe. Reemplazar por la URL real
 * del checkout cuando se cree (subdominio sugerido, a confirmar).
 */
const CHECKOUT_URL = 'https://solar-pv-battery-diagnostic-pro.impultienda.ar/checkout';
const included = ['6 complete volumes, 300 pages', '159 Split-and-Prove Cards', '40 field worksheets (WS-01 to WS-40)', '5 instant-use bonuses, incl. fillable PDFs', 'Code columns: US, Canada, UK & Australia', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="topo-light w-full bg-paper-dark text-pine" data-id="element-250" data-mp="20rjv3vokl2u1">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-251" data-mp="3c8a6rubrimv1">
        <div className="text-center" data-id="element-252" data-mp="3c7ryfzbtsi6r">
          <p className="eyebrow text-ember-deep" data-id="element-253" data-mp="3vzgsnq5g94xt">Complete pack</p>
          <h2 id="pricing-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-pine sm:text-6xl" data-id="element-254" data-mp="3vz7323obgzsn">
            Everything you need for every service call
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-paper-dark bg-white shadow-card" data-id="element-255" data-mp="erv4f8dhayfv">
          <div className="bg-forest px-5 py-5 text-center" data-id="element-256" data-mp="3d9qmy805eyr4">
            <h3 className="font-display text-2xl text-paper sm:text-3xl" data-id="element-257" data-mp="3d74fe8d9cj8w">
              Solar PV &amp; Battery Diagnostic Pro — Complete Pack
            </h3>
            <p className="mt-1 font-mono text-[12px] font-bold uppercase tracking-wider text-ember" data-id="element-258" data-mp="3n6d7evokbnsm">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-259" data-mp="2uizhvin71uij">
            <div className="rounded-2xl bg-forest-deep px-3 pb-4 pt-5" data-id="element-260" data-mp="2uhy4v8mmaxy6">
              <ProductStack data-id="element-261" data-mp="2zgrc4jbb9spw" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-262" data-mp="2zfg4g8eqw0ti">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-263" data-mp="2rei8ybdycboj">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-moss-soft" data-id="element-264" data-mp="2mhi4g4wr3gzj">
                    <CheckIcon className="h-3 w-3 text-moss-deep" aria-hidden="true" data-id="element-265" data-mp="2w7l3omugtr6b" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-paper-dark pt-6 text-center" data-id="element-266" data-mp="28jts5lgr1i63">
              <p className="text-[13px] text-pine-soft" data-id="element-267" data-mp="23kqqmazz9u2v">
                Regular price{' '}
                <span className="text-pine-muted line-through" data-id="element-268" data-mp="2ihhougxx0zqw">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-269" data-mp="2dfinfclqkcwl">
                <span className="mt-2.5 font-display text-3xl" data-id="element-270" data-mp="3tuag7qmsnm6f">$</span>
                <span className="font-display text-7xl leading-[0.9] sm:text-8xl" data-id="element-271" data-mp="3owilkourllyj">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-pine-muted" data-id="element-272" data-mp="9c6sd2ukqx2">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-273" data-mp="57dtr93e9adt">
                <span className="rounded border border-ember bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine" data-id="element-274" data-mp="3ngo0yj2kfkub">
                  Save $42
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-275" data-mp="j26cshiht8p5">
                  One-time payment
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-276" data-mp="a7rxiexypy61">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-pine-soft" data-id="element-277" data-mp="11yfwplg2sth2">
                That&apos;s about 17¢ a card — less than one wasted truck roll.
              </p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-278" data-mp="3f7sa5uaju1t7">
                Get Diagnostic Pro now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-pine-muted" data-id="element-279" data-mp="3a74dot3jwsrl">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-pine-soft" data-id="element-280" data-mp="3180s9igww19x">
                <li className="flex items-center gap-1.5" data-id="element-281" data-mp="1svqk0jssu6t">
                  <LockIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-282" data-mp="1ugirjin411i" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-283" data-mp="3o7f1todh7t92">
                  <ZapIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-284" data-mp="3o5u8u36t8idb" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-285" data-mp="kk5bd5z0r5dp">
                  <ShieldCheckIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-286" data-mp="fsewqnt1tvgh" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-pine-muted" data-id="element-287" data-mp="23dyd81n284y4">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}